import { useEffect, useState } from "react";
import { Modal, Table, Badge, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { general } from "../../../store/action";
import {
  isShowModalDataSelector,
  modalDataSelector,
  modalNameSelector,
} from "../../../store/selector/general";
import Icon from "../general/icon";

const SakhadServiceDetailModal = ({
  modalData,
  modalName,
  isShowModalData,
  handleHideModal,
}: any) => {
  const [showState, setShowState] = useState(false);
  const [service, setService] = useState<any>(null);

  useEffect(() => {
    if (isShowModalData && modalName === "sakhadServiceDetailModal") {
      setShowState(true);

      // The log shows result is an array: [{"fullName": "...", ...}]
      // We take the first item if it's an array, otherwise take the object.
      const rawData = modalData;
      const extracted = Array.isArray(rawData) ? rawData[0] : rawData;
      setService(extracted);
      console.log("sakhad", extracted);
    } else {
      setShowState(false);
    }
  }, [isShowModalData, modalName, modalData]);

  const handleClose = () => {
    setShowState(false);
    handleHideModal();
  };

  /**
   * Helper to render rows for the info table
   * @param variant - Bootstrap color (danger, success, info, primary, etc.)
   */
  const InfoRow = ({
    label,
    value,
    isBadge = false,
    variant = "info",
  }: {
    label: string;
    value: any;
    isBadge?: boolean;
    variant?: "danger" | "success" | "info" | "primary" | "warning" | "dark";
  }) => (
    <tr className="border-bottom border-light">
      <td
        className="py-3 text-muted font-12 fw-semibold"
        style={{ width: "40%" }}
      >
        {label}
      </td>
      <td className="py-3 font-13 fw-bold text-dark text-end">
        {isBadge ? (
          <Badge
            bg={`${variant}-subtle`}
            className={`text-${variant} border border-${variant}-subtle px-3 py-2`}
          >
            {value || "---"}
          </Badge>
        ) : (
          <span className={variant !== "info" ? `text-${variant}` : ""}>
            {value || "---"}
          </span>
        )}
      </td>
    </tr>
  );

  return (
    <Modal
      show={showState}
      onHide={handleClose}
      centered
      size="lg"
      contentClassName="rounded-4 border-0 shadow"
    >
      <Modal.Header closeButton className="border-0 p-4 pb-2">
        <Modal.Title className="font-16 fw-bold d-flex align-items-center">
          <Icon name="notebook" />
          جزئیات کامل خدمت (ساخد)
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className="px-4 pt-0">
        {service ? (
          <div className="table-responsive">
            <Table borderless hover className="m-0">
              <tbody>
                <InfoRow label="نام کامل (انگلیسی)" value={service.fullName} />
                <InfoRow label="نام فارسی" value={service.persianName} />
                <InfoRow label="نام لاتین" value={service.latinName} />
                <InfoRow
                  label="شناسه ملی خدمت"
                  value={service.nationalNumber}
                  isBadge
                  variant="primary"
                />
                <InfoRow
                  label="شناسه ملی والد"
                  value={service.parentNationalNumber}
                />
                <InfoRow label="شکل خدمت" value={service.shapeName} />
                <InfoRow label="شکل (کد)" value={service.shape} />

                {/* --- COVERAGE ROW --- */}
                <InfoRow
                  label="وضعیت پوشش بیمه"
                  // value={service.isCovered === "2" ? "دارای پوشش" : "بدون پوشش"}
                  value={
                    service.isCovered == 2
                      ? "عدم پوشش"
                      : service.isCovered == 1
                        ? " برای پوشش جانبازان"
                        : "تحت پوشش برای همگان"
                  }
                  isBadge
                  // highlight to red (danger) if its == 2 and otherwise green (success)
                  variant={
                    service.isCovered === 0 || service.isCovered === 1
                      ? "success"
                      : "danger"
                  }
                />

                <InfoRow
                  label="استفاده در داروهای ترکیبی"
                  value={
                    service.usedInCombinationDrugs === "true" ? "بله" : "خیر"
                  }
                  isBadge
                  variant={
                    service.usedInCombinationDrugs === "true"
                      ? "success"
                      : "dark"
                  }
                />
              </tbody>
            </Table>
          </div>
        ) : (
          <div className="text-center py-5 text-muted">
            <Icon name="info-circle" />
            داده‌ای یافت نشد.
          </div>
        )}
      </Modal.Body>

      <Modal.Footer className="border-0 p-4 pt-0">
        <Button
          variant="primary"
          className="w-100 rounded-3 py-2 fw-bold"
          onClick={handleClose}
        >
          متوجه شدم
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = (state: any) => ({
  modalData: modalDataSelector(state),
  modalName: modalNameSelector(state),
  isShowModalData: isShowModalDataSelector(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  handleHideModal: () => dispatch(general.handleHideModal()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SakhadServiceDetailModal);
